var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFooterEmail = function SvgFooterEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4a4a4a",
    className: "stroke-colored-el"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14.5a1.5 1.5 0 001.5-1.5V7A1.5 1.5 0 0015 5.5H5A1.5 1.5 0 003.5 7v6A1.5 1.5 0 005 14.5h10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52 6.757l5.608 4.006a1.5 1.5 0 001.744 0l5.608-4.006A1.5 1.5 0 0015 5.5H5a1.5 1.5 0 00-1.48 1.257z"
  }))));
};
export default SvgFooterEmail;